const REFRESH_TOKEN_KEY = "vt_refresh_token";

/**
 * If no OfficeRuntime (eg, you're forcibly running the AddIn
 * in the Browser), then just default back to localStorage.
 */
const getStorage = async () => {
  if (!window.OfficeRuntime) {
    return window.localStorage;
  }

  return window.OfficeRuntime.storage;
};

const tokenStorage = {
  async getRefreshToken() {
    const storage = await getStorage();
    return (await storage.getItem(REFRESH_TOKEN_KEY)) ?? null;
  },

  async setRefreshToken(token) {
    (await getStorage()).setItem(REFRESH_TOKEN_KEY, token);
  },

  async clearRefreshToken() {
    (await getStorage()).removeItem(REFRESH_TOKEN_KEY);
  },
};

export default tokenStorage;
